(ns renolit-roofing-service.main
  ;; NOTE: The `@js-joda/timezone` require is to load time zone
  ;; related data from the library. We need that data when dealing
  ;; with time zones related operations. Without this `cljc.java-time`
  ;; functions don't work as expected when dealing with time
  ;; zones. So, we only need the require for its side-effects and
  ;; nothing else.
  (:require ["@js-joda/timezone"]
            [day8.re-frame.http-fx]
            [dev.gethop.session.re-frame.cognito :as session]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [reagent.dom.client :as rdc]
            [renolit-roofing-service.config :as client.config]
            [renolit-roofing-service.layout.display-item.impl]
            [renolit-roofing-service.layout.info-bar :as info-bar]
            [renolit-roofing-service.layout.menu :as menu]
            [renolit-roofing-service.layout.sidebar :as layout.sidebar]
            [renolit-roofing-service.localization :as localization]
            [renolit-roofing-service.mobile :as mobile]
            [renolit-roofing-service.routes :as routes]
            [renolit-roofing-service.tooltip :as tooltip]
            [renolit-roofing-service.tooltip.generic-popup :as tooltip.generic-popup]
            [renolit-roofing-service.user :as client.user]
            [renolit-roofing-service.view :as view]
            [renolit-roofing-service.websocket]))

(rf/reg-event-fx
 ::init-cognito
 (fn [{:keys [db]} _]
   {:fx [[:dispatch [::session/set-config {:oidc (get-in db [:config :cognito])}]]
         [:dispatch [::client.user/fetch-user-data
                     {:on-success-evt [::routes/init-routes]
                      :on-failure-evt [::routes/init-routes]}]]]}))

(rf/reg-event-fx
 ::on-config-loaded
 (fn [_ _]
   {:fx [[:dispatch [::init-cognito]]]}))

(rf/reg-event-fx
 ::load-app
 (fn [_ _]
   {:db {}
    :fx [[:dispatch [::client.config/load-config [::on-config-loaded]]]
         [:dispatch [::localization/set-browser-language]]]}))

(defn app
  []
  (let [mobile? (rf/subscribe [::mobile/mobile?])]
    (r/create-class
     {:component-did-mount #(do (menu/setup-resize-listener!)
                                (menu/setup-global-click-listener!)
                                (mobile/add-resize-listener))
      :reagent-render
      (fn []
        [:div#app-container.app-container
         {:on-click #(tooltip/destroy-on-click-out (.. % -target))}
         [menu/menu-portal-wrapper]
         [tooltip.generic-popup/main]
         (when-not @mobile?
           [layout.sidebar/main])
         [info-bar/main]
         [view/main]])})))

(defn dev-setup
  []
  (if goog.DEBUG
    (do
      ;; Reenable log level logs no-ops for dev environment.
      (rf/set-loggers! {:log js/console.log})
      (enable-console-print!)
      (println "Dev mode"))
    ;; Make log level logs no-ops for production environment.
    (rf/set-loggers! {:log (fn [& _])})))

(defonce root
  (rdc/create-root (.getElementById js/document "app")))

(defn mount-root
  []
  (rf/clear-subscription-cache!)
  (rdc/render root [app]))

(defn ^:dev/after-load re-render
  []
  (mount-root))

(defn ^:export init
  []
  (dev-setup)
  (rf/dispatch-sync [::load-app])
  (mount-root))
